import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
import Assignment_Card from './Assignment_Card';
import EventCard from '../Card/EventCard';
import Amplify, { Auth } from 'aws-amplify';
import config from '../../aws-exports';
import Lottie from 'react-lottie';
import { default as animationData } from '../../assets/loader.json';
import { useLocation } from 'react-router';
import batchImg from '../../assets/images/challenge-banner.png';
import { cx } from '@emotion/css';
import * as styles from './assignment.style.js';
import { withAuthenticator, AmplifySignOut } from 'aws-amplify-react';



Amplify.configure(config);
function AssignmentEventsScreen(props) {
  const [events, set_events] = useState([]);
  const [loadedevents, set_loadedevents] = useState(false);

  let data1 = useLocation();
  ////console.log("Calling EventsScreen.....")
  ////console.log(data1.state)
  // const getToken = async () => {
  //   let user = null;
  //   Auth.currentSession().then((res) => {
  //     let accessToken = res.getAccessToken();
  //     let jwt = accessToken.getJwtToken();
  //     //////console.log(res)
  //     //////console.log(Auth.user.username)
  //     //////console.log(props.category)
  //     //this.props.setCategory(String(Auth.user.username))
  //     user = await Auth.currentAuthenticatedUser();


  //     getEventsfromDB(Auth.user.username, jwt);
  //   });
  // };

  const getToken = async () => {
    try {

      const res = await Auth.currentSession();
      let accessToken = res.getAccessToken();
      let jwt = accessToken.getJwtToken();
      const user = await Auth.currentAuthenticatedUser();

      if (user.username.includes("Google_")) {



        getEventsfromDB(user.attributes['email'], jwt);
      }
      else {

        getEventsfromDB(user.username, jwt);


      }


    } catch (err) {
      // console.log(err)
    }
  };







  const getEventsfromDB = async (username, jwt) => {
    const category = data1.state;
    var categoryreplace = category.category.replace(/%20/g, ' ');
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      // body: JSON.stringify({'question': id , 'tablename': category+"Questions",'level': level})
      body: JSON.stringify({
        username: username,
        category: categoryreplace,
        eventtype: 'Assignments',
      }),
    };
    ////console.log(requestOptions)
    const response = await fetch(
      `https://api.dev.quizwizard.net/quiz/getassignmentevents`,
      requestOptions
    );
    const data = await response.json();
    //////console.log('Output from the API is ')
    //////console.log(data)

    var i, j;
    var loopData = [];
    var count = 0;
    for (i = 0; i < data.length; i++) {
      //////console.log(data[i]['events'][0])
      for (j = 0; j < data[i]['events'].length; j++) {
        //////console.log(data[i]['events'][j])
        loopData[count] = data[i]['events'][j];
        count = count + 1;
      }

      //loopData[i] = data[i]['events']
      // for(j=0; j < data[i]['events']; j++){
      //   ////console.log(data[i]['events'][j])
      //   loopData[count] = data[i]['events'][j]
      //   count = count + 1
      // }
    }
    // ////console.log(data[0]['events'])

    //////console.log(loopData)
    //////console.log(loopData)
    //////console.log(data[0]['events'])
    //set_events(data[0]['events'])
    set_events(loopData);
    set_loadedevents(true);
  };
  useEffect(() => {
    // You need to restrict it at some point
    // This is just dummy code and should be replaced by actual
    // ////console.log("useEffect called on EventsScreen")
    getToken();
    document.title = 'Assignments';
  }, []);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };



  let eventCards = events.map((events) => {
    return (
      <div className="col-md-4">
        <Col className="py-2 border rounded">
          <EventCard
            imgsrc={'../assets/' + events.name + '.png'}
            title="Algebra"
            key={events.id}
            levels={events.levels}
            totalquestions={events.totalquestions}
            event={events}
            category={data1.state}
            target=""
          />

          {/* <Assignment_Card key={events.id} levels={events.levels} totalquestions = {events.totalquestions} event={events} /> */}
        </Col>
      </div>
    );
  });
  return (
    <div>
      {loadedevents ? (
        <div>
          <div className={cx(styles.batchBanner)}>
            <img src={batchImg} alt="" />

          </div>
          <div className={cx(styles.batchTitle)}>
            My Challenges
          </div>
          <div className={cx(styles.allChallengesFluid)}>
            <Row>{eventCards}</Row>
          </div>
        </div>
      ) : (
        <div className="welcomecenter">
          <Lottie options={defaultOptions} height={400} width={400} />
        </div>
      )}
    </div>
  );
}
export default AssignmentEventsScreen;
